import { NAME } from '../constants/name';
export const getCoreState = (state) => state[NAME];
